<div class="row">
  <div class="col-12">
    <h2 id="propertiesTransferred">Informations sur les enfants</h2>

    <magieno-boolean-select
    [advancedFormControl]="incomeTaxPersonalForm.formElements.isCareExpensesCalculated | asAdvancedFormControl"></magieno-boolean-select>

    @for (childForm of this.children.formGroups; track childForm; let i = $index) {
      <div class="card mt-4">
        <div class="row card-body">
          <div class="row d-flex justify-content-between">
            <div class="d-flex" style="width: fit-content">
              <h3 [id]="'enfant-' + (i + 1)">Enfant #{{ i + 1 }}</h3>
            </div>
            <div class="dropdown d-flex" style="width: fit-content">
              <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                data-expanded="false" href="#" role="button">
                <i class="fe fe-more-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a (click)="removeChild(i); $event.preventDefault()" class="dropdown-item"
                  href="#">
                  Supprimer
                </a>
              </div>
            </div>
          </div>
          <app-rrsp-personal-tax-child-form #property [childForm]="childForm" [form]="this.form"
          [index]="i"></app-rrsp-personal-tax-child-form>
        </div>
      </div>
    }

    <div class="card">
      <a (click)="this.addChild(); $event.preventDefault()" class="card-body" href="#propertiesTransferred"
        id="add_property_transferred">
        + Ajouter un enfant
      </a>
    </div>

  </div>
</div>